import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3522a34e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3522a34e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3522a34e')) {
      api.createRecord('3522a34e', component.options)
    } else {
      api.reload('3522a34e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3522a34e&scoped=true", function () {
      api.rerender('3522a34e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/closing/index.vue"
export default component.exports